<div class="mark-done-modal">
    <h2 mat-dialog-title>{{ getDialogTitle() }}</h2>
    
    <mat-dialog-content>
      <p class="description">Please select the appropriate attendance status for this appointment:</p>
      
      <div class="status-options">
        <mat-radio-group [(ngModel)]="selectedStatus" (change)="onStatusChange($event)">
          
          <!-- SHOW Option -->
          <div class="status-option-wrapper">
            <mat-radio-button value="SHOW" color="primary" class="status-radio">
              <span class="status-label">
                <mat-icon>check_circle</mat-icon>
                Show - Lead attended
              </span>
            </mat-radio-button>
            
            <!-- Outcome Section (appears below SHOW option) -->
            <div class="outcome-container" [class.expanded]="selectedStatus === 'SHOW' && showOutcomes">
              @if (selectedStatus === 'SHOW' && showOutcomes) {
                <div class="outcome-section">
                  @if (isLoadingOutcomes) {
                    <div class="loading-container">
                      <mat-spinner diameter="24"></mat-spinner>
                      <span>Loading outcomes...</span>
                    </div>
                  } @else if (activityOutcomes.length > 0) {
                    <div class="outcome-header">
                      <mat-icon class="outcome-icon">assignment_turned_in</mat-icon>
                      <h4>Select Appointment Outcome</h4>
                    </div>
                    
                    <div class="outcome-list">
                      @for (outcome of activityOutcomes; track outcome.outcome.id) {
                        <div 
                          class="outcome-item" 
                          [class.selected]="selectedOutcome === outcome.outcome.id"
                          [class.disabled]="isOutcomeDisabled(outcome)"
                          [matTooltip]="getOutcomeDisabledTooltip(outcome)"
                          (click)="!isOutcomeDisabled(outcome) && selectOutcome(outcome.outcome.id)">
                          <div class="outcome-content">
                            <div class="outcome-name">{{ outcome?.outcome?.name }}</div>
                            @if (outcome?.outcome?.description) {
                              <div class="outcome-description">{{ outcome?.outcome?.description }}</div>
                            }
                            @if (isOutcomeDisabled(outcome)) {
                              <div class="outcome-disabled-reason">{{ getOutcomeDisabledTooltip(outcome) }}</div>
                            }
                          </div>
                          <mat-icon class="selection-indicator">
                            {{ selectedOutcome === outcome.outcome.id ? 'radio_button_checked' : 'radio_button_unchecked' }}
                          </mat-icon>
                        </div>
                      }
                    </div>
                    
                    @if (isOutcomeRequired && !selectedOutcome) {
                      <div class="requirement-notice">
                        <mat-icon>warning</mat-icon>
                        <span>An outcome selection is required for this appointment type.</span>
                      </div>
                    }
                  } @else {
                    @if(roleUser == 'ADMIN'){
                    <div class="no-outcomes">
                      <mat-icon>info_outline</mat-icon>
                      <span>No outcomes are configured for this activity type.</span>
                      <button mat-raised-button color="primary" (click)="goToOutcomeSettings()" type="button">
                        <mat-icon>add</mat-icon>
                        Create Outcome
                      </button>
                    </div>
                    }@else {
                      <div class="no-outcomes">
                        <mat-icon>info_outline</mat-icon>
                        <span>No outcomes are configured for this activity type.</span>
                        <span>Please contact an admin.</span>
                      </div>
                    }
                  }
                </div>
              }
            </div>
          </div>
          
          <!-- NO SHOW Option -->
          <div class="status-option-wrapper">
            <mat-radio-button value="NO_SHOW" color="warn" class="status-radio">
              <span class="status-label">
                <mat-icon>cancel</mat-icon>
                No-Show - Lead did not attend
              </span>
            </mat-radio-button>
          </div>

          <!-- RESCHEDULED Option -->
          <div class="status-option-wrapper">
            <mat-radio-button value="RESCHEDULED" color="primary" class="status-radio">
              <span class="status-label">
                <mat-icon>event_repeat</mat-icon>
                Reschedule - Set a new date/time
              </span>
            </mat-radio-button>
          </div>

          <!-- CANCEL Option -->
          <div class="status-option-wrapper">
            <mat-radio-button value="CANCEL" color="warn" class="status-radio">
              <span class="status-label">
                <mat-icon>block</mat-icon>
                Cancel - Appointment cancelled
              </span>
            </mat-radio-button>
          </div>

          

        </mat-radio-group>
      </div>
  
      <!-- Loading state -->
      @if (isLoading) {
        <div class="main-loading-container">
          <mat-spinner diameter="30"></mat-spinner>
          <span>Processing...</span>
        </div>
      }
    </mat-dialog-content>
    
    <mat-dialog-actions>
      <mat-icon
        *ngIf="roleUser === 'ADMIN'"
        class="settings-icon"
        matTooltip="Configure outcomes"
        matTooltipPosition="above"
        (click)="goToOutcomeSettings()">
        settings
      </mat-icon>
      <div class="actions-spacer"></div>
      <button mat-button (click)="onCancel()" [disabled]="isLoading">Cancel</button>
      <button
        mat-raised-button
        color="primary"
        [disabled]="!selectedStatus || isLoading || (selectedStatus === 'SHOW' && isOutcomeRequired && !selectedOutcome)"
        (click)="handleConfirmClick($event)"
        type="button"
      >
        @if (isLoading) {
          <mat-spinner diameter="16"></mat-spinner>
        } @else {
          {{ getConfirmButtonText() }}
        }
      </button>
    </mat-dialog-actions>
  </div>